var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feedback-box", on: { click: _vm.openMagicEditor } },
    [
      _c("div", { staticClass: "feedback-btn" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm._f("trans")("Try out AI Inpainting Alpha")) +
            " "
        ),
        _c("i", { staticClass: "far fa-arrow-right" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }